import React from 'react';
import InstitutionNavbar from '../components/instituteNavbar';
import InstSidebar from '../components/instSidebar';
import InstHeroComponent from '../components/InstHeroComponent';
import JobsList from '../components/jobslist';
import Footer from '../components/Footer';
import images from '../constants/images';

const InstitutionHomePage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Navbar */}
      <InstitutionNavbar />

      {/* Content Layout */}
      <div
        className="flex flex-col flex-1 md:flex-row bg-gray-50 mt-[120px]"
      >


        {/* Sidebar */}
        <aside className="hidden md:block md:w-64 bg-[#f8f9fa] p-4 shadow md:min-h-[calc(100vh-4rem)]">

          <InstSidebar />
        </aside>

        {/* Main Content */}
        <main className="flex-1 overflow-auto md:p-6">
          <div className="mx-auto w-full max-w-[1200px] px-4 py-4 md:px-0">


            <InstHeroComponent />

            {/* Job Listings */}
            <div className="mt-1">
              <JobsList />
            </div>
          </div>
        </main>
      </div>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Icon */}
      <a
        href="https://wa.me/+919739866955"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed z-50 p-3 transition-colors duration-300 bg-green-500 rounded-full shadow-lg bottom-5 right-5 hover:bg-green-600"
      >
        <img
          src={images.WhatsaApp}
          alt="WhatsApp"
          className="w-10 h-10"
        />
      </a>
    </div>
  );
};

export default InstitutionHomePage;
